export const ERROR_MESSAGE_MAPPER = {
  noFace: 'No face detected',
  multiFace: 'More than one person is detetcted',
  // mobile: 'Usage of mobile is detected',
  // laptop: 'Usage of laptop is detected',
};

export const REALTIME_ALERT_PARAMETERS_LOCALSTORAGE_KEY =
  'REALTIME_ALERT_PARAMETERS';

export const ERROR_MEESAGE_PRIORITY = {
  noFace: 0,
  multiFace: 1,
  // mobile: 4,
  // laptop: 3,
};

export const REALTIME_FEEDBACK_LIST = [
  'Different face detected',
  'Multiple faces detected',
  'No face detected',
  'Unauthorized objects detected',
  'Multiple Monitors detected ',
];

export const REALTIME_FEEDBACK_MODAL_TITLE = 'Suspicious Activity Detected!';

export const REALTIME_FEEDBACK_MODAL_DESCRIPTION = `Ensure you are following webcam proctoring guidelines and click on the “PROCEED TO <%= productTypeUpper %>” button. Please note these instances can affect your candidature.`;

export const REALTIME_FEEDBACK_ERROR_WINDOW = 2;

export const DEFAULT_ERROR_LIST = {
  noFace: 0,
  multiFace: 0,
  // mobile: 0,
  // laptop: 0,
};
